import axios from 'axios';

class CrmApi {
  constructor(brandCode, sessionParams, cremaDomainPrefix = '') {
    this.sessionParams = sessionParams;
    this.api = axios.create({
      baseURL: `//${cremaDomainPrefix}target.cre.ma/${brandCode}/crm`
    });
  }

  get(url, params) {
    return this.api.get(url, { params: { ...this.sessionParams, ...params } });
  }

  fetchLandingPage() {
    return this.get('/landing_page');
  }
}

export default CrmApi;
